export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      about: "À propos",
      blog: "Blog",
      contact: "Contact",
      cta: "Prendre rendez-vous",
    },
    hero: {
      eyebrow: "Cybersécurité · GRC · Conformité",
      title_pre: "Sécurité de l'information",
      title_em: "exigeante,",
      title_post: "pragmatique.",
      subtitle:
        "RAYTECH Advisory accompagne les organisations dans la maîtrise de leurs risques cyber, leur conformité réglementaire et la mise en place d'une gouvernance robuste.",
      cta_primary: "Discuter de votre projet",
      cta_secondary: "Découvrir nos services",
      kpi1: "+10 ans",
      kpi1_label: "d'expertise cyber",
      kpi2: "ISO 2700x · NIS2 · DORA · CMMC",
      kpi2_label: "CPCSC · LPM · PCI DSS — référentiels maîtrisés",
      kpi3: "Sur mesure",
      kpi3_label: "approche conseil",
    },
    services: {
      eyebrow: "Nos expertises",
      title: "Quatre piliers, une seule promesse : la maîtrise.",
      subtitle:
        "De l'audit technique à la gouvernance stratégique, RAYTECH Advisory couvre l'ensemble du cycle de vie de la sécurité de l'information.",
      items: [
        {
          tag: "01",
          title: "Audit & Pentest",
          desc:
            "Tests d'intrusion boîte noire / grise / blanche, audits de configuration, revues d'architecture et red teaming ciblé.",
          points: ["Pentest web & infra", "Audit code source", "Red Team & Phishing"],
        },
        {
          tag: "02",
          title: "Conseil GRC",
          desc:
            "Gouvernance, gestion des risques et conformité : ISO 27001, NIS2, DORA, EBIOS RM. Du diagnostic à la mise en œuvre.",
          points: ["ISO 27001 / 27002", "EBIOS Risk Manager", "Politique & comités"],
        },
        {
          tag: "03",
          title: "Mise en conformité",
          desc:
            "Accompagnement RGPD, NIS2, ISO. Cartographie, plan d'action, documentation et préparation aux audits.",
          points: ["RGPD & DPO externalisé", "NIS2 readiness", "Audit blanc"],
        },
        {
          tag: "04",
          title: "Formation & sensibilisation",
          desc:
            "Programmes de sensibilisation pour tous les collaborateurs et formations techniques pour les équipes IT/Sécurité.",
          points: ["Awareness sur mesure", "Phishing simulé", "Ateliers EBIOS"],
        },
      ],
    },
    about: {
      eyebrow: "Le cabinet",
      title: "RAYTECH Advisory — le conseil cyber qui parle business.",
      p1:
        "RAYTECH Advisory est un cabinet de conseil indépendant spécialisé en cybersécurité et gouvernance des risques. Nous combinons rigueur méthodologique et pragmatisme opérationnel pour des résultats mesurables.",
      p2:
        "Le cabinet intervient auprès de PME, ETI et grands groupes pour traduire les exigences réglementaires en actions concrètes — et faire de la sécurité un avantage compétitif, pas une contrainte.",
      bullets: [
        "Approche indépendante, libre de tout conflit d'intérêt produit",
        "Méthodologies reconnues : ISO, NIST, EBIOS RM, MITRE ATT&CK",
        "Livrables actionnables, jamais théoriques",
        "Suivi long terme et transfert de compétences",
      ],
      founder_role: "Cabinet de conseil · Cybersécurité & GRC",
    },
    process: {
      eyebrow: "Notre méthode",
      title: "Un parcours clair, en quatre étapes.",
      steps: [
        { n: "01", t: "Cadrage", d: "Comprendre votre contexte, vos enjeux et vos contraintes." },
        { n: "02", t: "Diagnostic", d: "Évaluation de la maturité et identification des écarts." },
        { n: "03", t: "Plan d'action", d: "Recommandations priorisées, chiffrées et planifiées." },
        { n: "04", t: "Mise en œuvre", d: "Accompagnement opérationnel jusqu'à la cible." },
      ],
    },
    blog: {
      eyebrow: "Insights",
      title: "Analyses & publications",
      subtitle:
        "Décryptages réglementaires, retours d'expérience et bonnes pratiques cyber.",
      read_more: "Lire l'article",
      all: "Voir tous les articles",
      back: "Retour au blog",
      min_read: "min de lecture",
      no_posts: "Aucun article pour le moment.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Parlons de votre projet.",
      subtitle:
        "Décrivez votre besoin en quelques lignes — nous revenons vers vous sous 24 heures ouvrées.",
      name: "Nom complet",
      email: "Email professionnel",
      company: "Société",
      subject: "Sujet",
      message: "Votre message",
      send: "Envoyer le message",
      sending: "Envoi en cours...",
      success: "Message envoyé. Nous revenons vers vous très vite.",
      error: "Une erreur est survenue. Merci de réessayer.",
      info_title: "Contact direct",
      info_email: "contact@raytech-advisory.fr",
      info_phone: "+33 6 58 50 09 52",
      info_phone_raw: "+33658500952",
      info_location: "14 rue Bausset, 75015 Paris",
      info_hours: "Lun. – Ven. · 9h – 18h",
    },
    trusted: {
      title: "Ils nous ont fait confiance",
    },
    call: {
      eyebrow: "Échange direct",
      title: "Programmer un appel téléphonique.",
      subtitle:
        "Choisissez un créneau qui vous convient — nous vous rappelons à l'heure indiquée pour un échange de 30 minutes, sans engagement.",
      name: "Nom",
      phone: "Téléphone",
      email: "Email",
      date: "Date souhaitée",
      time: "Créneau",
      slot_morning: "Matin (9h – 12h)",
      slot_afternoon: "Après-midi (14h – 18h)",
      topic: "Sujet de l'appel",
      submit: "Confirmer le rendez-vous",
      submitting: "Envoi...",
      success: "Demande enregistrée. Nous vous rappelons au créneau indiqué.",
      error: "Erreur lors de l'enregistrement. Réessayez ou utilisez le formulaire ci-dessous.",
    },
    footer: {
      tagline: "Cybersécurité & GRC — Conseil indépendant.",
      nav: "Navigation",
      legal: "Légal",
      legal_mentions: "Mentions légales",
      privacy: "Confidentialité",
      rights: "Tous droits réservés.",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      blog: "Insights",
      contact: "Contact",
      cta: "Book a meeting",
    },
    hero: {
      eyebrow: "Cybersecurity · GRC · Compliance",
      title_pre: "Information security,",
      title_em: "uncompromising",
      title_post: "and pragmatic.",
      subtitle:
        "RAYTECH Advisory helps organizations master their cyber risks, regulatory compliance, and build a robust governance posture.",
      cta_primary: "Discuss your project",
      cta_secondary: "Explore our services",
      kpi1: "10+ years",
      kpi1_label: "of cyber expertise",
      kpi2: "ISO 2700x · NIS2 · DORA · CMMC",
      kpi2_label: "CPCSC · LPM · PCI DSS — frameworks mastered",
      kpi3: "Tailored",
      kpi3_label: "advisory approach",
    },
    services: {
      eyebrow: "Our expertise",
      title: "Four pillars. One promise: mastery.",
      subtitle:
        "From technical audit to strategic governance, RAYTECH Advisory covers the entire information security lifecycle.",
      items: [
        {
          tag: "01",
          title: "Audit & Pentest",
          desc:
            "Black/grey/white box penetration tests, configuration audits, architecture reviews and targeted red teaming.",
          points: ["Web & infra pentest", "Source code audit", "Red Team & Phishing"],
        },
        {
          tag: "02",
          title: "GRC Consulting",
          desc:
            "Governance, risk and compliance: ISO 27001, NIS2, DORA, EBIOS RM. From diagnosis to implementation.",
          points: ["ISO 27001 / 27002", "EBIOS Risk Manager", "Policy & committees"],
        },
        {
          tag: "03",
          title: "Compliance",
          desc:
            "GDPR, NIS2, ISO support. Mapping, action plan, documentation and audit preparation.",
          points: ["GDPR & outsourced DPO", "NIS2 readiness", "Mock audit"],
        },
        {
          tag: "04",
          title: "Training & awareness",
          desc:
            "Awareness programs for all employees and technical training for IT/Security teams.",
          points: ["Tailored awareness", "Simulated phishing", "EBIOS workshops"],
        },
      ],
    },
    about: {
      eyebrow: "The firm",
      title: "RAYTECH Advisory — cyber consulting that speaks business.",
      p1:
        "RAYTECH Advisory is an independent consulting firm specialized in cybersecurity and risk governance. We combine methodological rigor with operational pragmatism to deliver measurable results.",
      p2:
        "The firm works with SMBs, mid-caps and large groups to translate regulatory requirements into concrete actions — turning security into a competitive advantage, not a constraint.",
      bullets: [
        "Independent approach, free from product conflicts of interest",
        "Recognized methodologies: ISO, NIST, EBIOS RM, MITRE ATT&CK",
        "Actionable deliverables, never theoretical",
        "Long-term support and skill transfer",
      ],
      founder_role: "Consulting firm · Cybersecurity & GRC",
    },
    process: {
      eyebrow: "Our method",
      title: "A clear journey, in four steps.",
      steps: [
        { n: "01", t: "Framing", d: "Understand your context, stakes and constraints." },
        { n: "02", t: "Diagnosis", d: "Maturity assessment and gap identification." },
        { n: "03", t: "Action plan", d: "Prioritized, costed and scheduled recommendations." },
        { n: "04", t: "Implementation", d: "Operational support to the target state." },
      ],
    },
    blog: {
      eyebrow: "Insights",
      title: "Analyses & publications",
      subtitle:
        "Regulatory deep-dives, lessons learned and cyber best practices.",
      read_more: "Read article",
      all: "View all articles",
      back: "Back to blog",
      min_read: "min read",
      no_posts: "No articles yet.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's discuss your project.",
      subtitle:
        "Describe your need in a few lines — we'll get back to you within 24 business hours.",
      name: "Full name",
      email: "Professional email",
      company: "Company",
      subject: "Subject",
      message: "Your message",
      send: "Send message",
      sending: "Sending...",
      success: "Message sent. We'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
      info_title: "Direct contact",
      info_email: "contact@raytech-advisory.fr",
      info_phone: "+33 6 58 50 09 52",
      info_phone_raw: "+33658500952",
      info_location: "France",
      info_hours: "Mon – Fri · 9am – 6pm",
    },
    call: {
      eyebrow: "Direct conversation",
      title: "Schedule a phone call.",
      subtitle:
        "Pick a slot that suits you — we'll call you back at the indicated time for a 30-minute discussion, no commitment.",
      name: "Name",
      phone: "Phone",
      email: "Email",
      date: "Preferred date",
      time: "Time slot",
      slot_morning: "Morning (9am – 12pm)",
      slot_afternoon: "Afternoon (2pm – 6pm)",
      topic: "Call topic",
      submit: "Confirm appointment",
      submitting: "Sending...",
      success: "Request received. We'll call you back at the chosen slot.",
      error: "Error while saving. Please retry or use the form below.",
    },
    footer: {
      tagline: "Cybersecurity & GRC — Independent advisory.",
      nav: "Navigation",
      legal: "Legal",
      legal_mentions: "Legal notice",
      privacy: "Privacy",
      rights: "All rights reserved.",
    },
  },
};
